<template>
  <div class="product-selection">
    <ul class="product-list list-inline">
      <li v-for="product in products" :key="product._id">
        <a @click.prevent="changeProduct(product)" href="#" :class="current_product._id == product._id ? 'active' : ''">
          <i :class="['fa', product.icon]"></i>
          <span class="sr-only" v-if="current_product._id == product._id">Current product: </span>
          <span class="sr-only" v-if="current_product._id !== product._id">Change products: </span>
          {{ getLexiconTranslation(product.lexiconKeys.name) }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  computed: {
    // current_product() {
    //   return this.$store.state.current_product;
    // },
    // products() {
    //   return this.$store.state.products;
    // }
    ...mapState(["current_product", "products"]),
    ...mapGetters(["getLexiconTranslation"])
  },
  mounted() {
    //this.$store.commit("getProducts");
    //this.$store.commit("getFromStations", this.current_product._id);
    //this.$store.commit("getFares", this.current_product._id);
  },
  created() {
    // this.$store.dispatch("fetchProducts");
    // this.$store.dispatch("fetchFares");
  },
  methods: {
    changeProduct(product) {
      if (product.family == 'bundle') {
        // Open Bundle Products on Betterez interface @Todo: replace with integrating booking flow once available.
        window.open('https://on.betterez.com/cart/' + product.accountId + '/bundle/' + product._id);
      } else {
        this.$store.dispatch("changeProduct", product).then(() => {
          this.$store.dispatch("fetchFares");
          this.$store.dispatch("fetchFromStations");
        });
      }
    }
  }
};
</script>
<style lang="scss">
.product-selection {
  position: relative;

}
.fa-bus{
  &::before{
    content:''!important;
    background: url('../assets/bus-icon.svg') no-repeat center center; 
    background-size:30px;
  }
}
.fa-train{
  &::before{
    content:''!important;
    background: url('../assets/train-icon.svg') no-repeat center center;
    background-size: 26px;
  }

}
.fa-road{
  &::before{
    content:''!important;
    background: url('../assets/multitrip-icon.svg') no-repeat center center;
    background-size: 29px;
  }
}


a.active .fa-bus{
  &::before{
    background: url('../assets/bus-icon-active.svg') no-repeat center center;
  }
}
a.active .fa-train{
  &::before{
    background: url('../assets/train-icon-active.svg') no-repeat center center;
  }
}
a.active .fa-road{
  &::before{
    background: url('../assets/multitrip-icon-active.svg') no-repeat center center;
  }
}
.product-selection .fa-bus,
.product-selection .fa-train,
.product-selection .fa-road{
  &::before{
    width:30px;
    height:35px;
    display: inline-block;
    margin-right:10px;
  }
}
</style>
